/*
 *
 * RubiconePromoCarouselPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 25-Aug-2025
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import RubiconePromoCarouselPopup from './RubiconePromoCarouselPopup'
import { nullSafe } from 'Utility/globalMethods'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup())

})

const mapStateToProps = (state) => ({
  infoPage: nullSafe(() => state.RubiconeGold.switchConvoInfo, {}),
  promoCashbackConf: nullSafe(() => state.RubiconeGold.promoCashbackConf, {}),
  entrypoint: nullSafe(() => state.routingUtility.entryPoint, '/')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(RubiconePromoCarouselPopup)
